import type { Type } from '@angular/core';
import { WidgetGhostType, WidgetShellType } from './data-viz-widget.interface';
import { ComparisonGhostComponent } from './ghosts/comparison/comparison-ghost';
import { HistogramGhostComponent } from './ghosts/histogram/histogram-ghost';
import { PointsCloudGhostComponent } from './ghosts/points-cloud/points-cloud-ghost';
import { TableGhostComponent } from './ghosts/table/table-ghost';
import type { WidgetGhost } from './ghosts/widget-ghost.class';
import { CardShellComponent } from './shells/card/card-shell';
import { EmptyShellComponent } from './shells/empty/empty-shell';
import type { WidgetShell } from './shells/widget-shell.class';

export function getShellComponent(shellType: WidgetShellType): Type<WidgetShell<any>> {
    const shellsMap: Record<WidgetShellType, Type<WidgetShell<any>>> = {
        [WidgetShellType.CARD]: CardShellComponent,
        [WidgetShellType.EMPTY]: EmptyShellComponent
    };

    return shellsMap[shellType];
}

export function getGhostComponent(ghostType: WidgetGhostType): Type<WidgetGhost<any, any>> {
    const ghostsMap: Record<WidgetGhostType, Type<WidgetGhost<any, any>>> = {
        [WidgetGhostType.HISTOGRAM]: HistogramGhostComponent,
        [WidgetGhostType.TABLE]: TableGhostComponent,
        [WidgetGhostType.POINTS_CLOUD]: PointsCloudGhostComponent,
        [WidgetGhostType.COMPARISON]: ComparisonGhostComponent
    };

    return ghostsMap[ghostType];
}
